import { createContext, useContext, useEffect, useState } from "react";
import { api, API, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const googleToken = params.get("google_token");

    if (googleToken) {
      localStorage.setItem(TOKEN_KEY, googleToken);

      // Remove the token from the browser URL
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );

      api
        .get("/auth/me")
        .then((res) => setUser(res.data))
        .catch(() => {
          localStorage.removeItem(TOKEN_KEY);
          setUser(false);
        })
        .finally(() => setReady(true));

      return;
    }

    const token = localStorage.getItem(TOKEN_KEY);

    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }

    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
      })
      .finally(() => setReady(true));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const persist = (data) => {
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    persist(res.data);
  };

  const register = async (email, password, name) => {
    const res = await api.post("/auth/register", { email, password, name });
    persist(res.data);
  };

  const loginWithGoogle = () => {
  window.location.href = `${API}/auth/google`;
};

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, loginWithGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
